var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-client"},[_c('div',{on:{"click":_vm.changeOrder}},[_c('label',{attrs:{"for":_vm.column}},[_vm._v(_vm._s(_vm.$t("b2c." + _vm.column)))]),_c('i',{staticClass:"fa",class:{
        'fa-arrow-up': _vm.isAscending,
        'fa-arrow-down': _vm.isAscending === false,
        'fa-minus': _vm.isAscending === null,
      }})])])}
var staticRenderFns = []

export { render, staticRenderFns }